<template>
  <div class="generate-order">
    <div class="generate-order-container">
      <e-search
        :count="100"
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        :list-type-info="listTypeInfo"
        :width="filterInfo.width"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <div v-if="myPurchaseRequestData.length > 0" class="generate-order-top">
      <div class="generate-order-top-left">
        <div class="generate-order-top-left-input">
          <input
            v-if="totalCount != selectCount"
            id="allSelect"
            v-model="checked"
            type="checkbox"
            :class="{ 'no-border': totalCount != selectCount }"
            @click="checkAll"
          />
          <div v-else class="check-img">
            <img
              src="@/assets/img/purchase/right.svg"
              alt=""
              @click="checkAll"
            />
          </div>
          <p>全选采购申请明细</p>
        </div>
        <div class="generate-order-top-left-sort" @click="sortChange">
          <div>接收时间排序</div>
          <img
            v-show="!isSort"
            src="@/assets/img/purchase/up copy.png"
            alt=""
          />
          <img
            v-show="isSort"
            src="@/assets/img/purchase/down copy.png"
            alt=""
          />
        </div>
      </div>
      <!--      <div class="generate-order-top-right" @mouseenter="enter(true)" @mouseleave="leave(false)" @click="deleteSelectedPurchaseRequest">-->
      <!--        <img v-show="!isDel" src="~assets/images/del.png" alt="" />-->
      <!--        <img v-show="isDel" src="~assets/images/del_active.png" alt="" />-->
      <!--        <div :class="{ 'text-color': isDel }">删除已选采购申请</div>-->
      <!--      </div>-->
    </div>
    <div
      v-for="(item, index) in myPurchaseRequestData"
      :key="index"
      class="generate-order-main"
      :class="{
        'is-active': checkModel.indexOf(item.purchaseRequisitionId) !== -1,
      }"
    >
      <div class="order-item" :class="{ 'margin-l': index == 9 }">
        <div class="index-item">{{ index + 1 }}</div>
        <div class="order-item-main">
          <div v-if="isSelect(item)" class="left-line"></div>
          <div class="order-item-left">
            <input
              v-model="checkModel"
              type="checkbox"
              :value="item.purchaseRequisitionId"
              :class="{
                'no-border':
                  typeof item.purchasePlanItemListVOList == 'undefined' ||
                  checkModel.indexOf(item.purchaseRequisitionId) == -1,
              }"
              class="img-input"
              @change="checkPurchaseRequest(item, index)"
            />
            <div
              v-if="checkModel.indexOf(item.purchaseRequisitionId) != -1"
              class="img-right"
              @click="cancleClick(item, index)"
            >
              <img src="@/assets/img/purchase/right.svg" alt="" />
            </div>
          </div>
          <div class="order-item-middle">
            <ul>
              <li>
                <div
                  class="text"
                  :class="{
                    isActive:
                      checkModel.indexOf(item.purchaseRequisitionId) !== -1,
                  }"
                >
                  采购申请号：
                </div>
                <e-tooltip
                  :content="item.purchaseRequisitionCode"
                  :set-length="12"
                />
              </li>
              <li>
                <div
                  class="text"
                  :class="{
                    isActive:
                      checkModel.indexOf(item.purchaseRequisitionId) !== -1,
                  }"
                >
                  商品名称：
                </div>
                <e-tooltip :content="item.productName" :set-length="9" />
              </li>
              <li class="li-width-196">
                <div
                  class="text"
                  :class="{
                    isActive:
                      checkModel.indexOf(item.purchaseRequisitionId) !== -1,
                  }"
                >
                  商品规格：
                </div>
                <!--                <el-tooltip-->
                <!--                  class="item"-->
                <!--                  effect="dark"-->
                <!--                  :content="item.productOptions"-->
                <!--                  placement="top"-->
                <!--                  :manual="item.productOptions && item.productOptions.length >= 2 ? false : true"-->
                <!--                >-->
                <!--                  <div class="text-value ellipsis text-value-number150">-->
                <!--                    {{ item.productOptions }}-->
                <!--                  </div>-->
                <!--                </el-tooltip>-->
                <e-tooltip :content="item.productOptions" :set-length="12" />
              </li>
              <li>
                <div
                  class="text"
                  :class="{
                    isActive:
                      checkModel.indexOf(item.purchaseRequisitionId) !== -1,
                  }"
                >
                  期望到货时间：
                </div>
                <div class="text-value">
                  {{
                    item.expectedArrivalDate
                      ? item.expectedArrivalDate.split(' ')[0]
                      : ''
                  }}
                </div>
              </li>
              <li>
                <div
                  class="text"
                  :class="{
                    isActive:
                      checkModel.indexOf(item.purchaseRequisitionId) !== -1,
                  }"
                >
                  平台接收时间：
                </div>
                <e-tooltip :content="item.createTime" :set-length="12" />
              </li>
              <li>
                <div
                  class="text"
                  :class="{
                    isActive:
                      checkModel.indexOf(item.purchaseRequisitionId) !== -1,
                  }"
                >
                  应采数量：
                </div>
                <div class="text-value">{{ item.requiredQuantity }}</div>
              </li>
              <li style="width: 154px">
                <div
                  class="text"
                  :class="{
                    isActive:
                      checkModel.indexOf(item.purchaseRequisitionId) !== -1,
                  }"
                >
                  剩余应采数量：
                </div>
                <div class="text-value ellipsis">
                  {{
                    item.remainingQuantity != null
                      ? item.remainingQuantity
                      : item.remainingQuantity
                  }}
                </div>
              </li>
              <li>
                <div
                  class="text"
                  :class="{
                    isActive:
                      checkModel.indexOf(item.purchaseRequisitionId) !== -1,
                  }"
                >
                  商品行号：
                </div>
                <div class="text-value ellipsis">{{ item.lineNumber }}</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="order-item-right">
          <eui-btn
            type="weak"
            @click.native.prevent="
              selectBtn(item.purchaseRequisitionId, item.productName)
            "
            >选择商品</eui-btn
          >
          <div>
            <eui-btn
              type="text"
              @click.native.prevent="returnNum(item.purchaseRequisitionId)"
              >退回</eui-btn
            >
          </div>
        </div>
      </div>
      <div v-if="isSelect(item)" class="order-item-footer">
        <div class="commodity">
          <img src="@/assets/img/purchase/commodity.png" alt="" />
          <div class="order-item-footer-text">
            <p
              class="text"
              :class="{
                isActive: checkModel.indexOf(item.purchaseRequisitionId) !== -1,
              }"
            >
              商品名称：
            </p>
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.purchasePlanItemListVOList[0].productSkuName"
              placement="top"
            >
              <span class="ellipsis width text-value">
                {{ item.purchasePlanItemListVOList[0].productSkuName }}
              </span>
            </el-tooltip>
          </div>
        </div>
        <div>
          <p
            class="text"
            :class="{
              isActive: checkModel.indexOf(item.purchaseRequisitionId) !== -1,
            }"
          >
            商品规格：
          </p>
          <el-tooltip
            class="item"
            effect="dark"
            :content="
              setShoppingStandard(
                item.purchasePlanItemListVOList[0].productSkuOptions
              )
            "
            placement="top"
          >
            <span class="text-width-150 ellipsis text-value">
              {{
                setShoppingStandard(
                  item.purchasePlanItemListVOList[0].productSkuOptions
                )
              }}
            </span>
          </el-tooltip>
        </div>
        <div>
          <p
            class="text"
            :class="{
              isActive: checkModel.indexOf(item.purchaseRequisitionId) !== -1,
            }"
          >
            供应商:
          </p>
          <el-tooltip
            class="item"
            effect="dark"
            :content="item.purchasePlanItemListVOList[0].supplierCompanyName"
            placement="top"
          >
            <span class="text-width-150 ellipsis text-value">
              {{ item.purchasePlanItemListVOList[0].supplierCompanyName }}
            </span>
          </el-tooltip>
        </div>
        <div class="order-size">
          <p
            class="text"
            :class="{
              isActive: checkModel.indexOf(item.purchaseRequisitionId) !== -1,
            }"
          >
            采购数量
          </p>
          <div class="lw-3">
            <e-buy-num
              :e-height="30"
              :num.sync="item.purchasePlanItemListVOList[0].quantity"
              :item-data="item.purchasePlanItemListVOList[0]"
              @edit-num="
                handleChange(
                  item.purchasePlanItemListVOList[0].quantity,
                  item.purchasePlanItemListVOList[0].procurementPlanItemId
                )
              "
            ></e-buy-num>
          </div>
        </div>
      </div>
      <img
        v-show="isSelect(item)"
        src="@/assets/img/purchase/line.png"
        alt=""
        class="line-item"
      />
    </div>
    <div v-if="noDataFlag" class="no-data">
      <!-- <img src="~/assets/images/orderDetail/order-no.png" alt="" /> -->
      <p>贵公司当前暂无采购申请</p>
      <!-- <p>
        请
        <span @click="toBack">选择商品</span>
        下单
      </p> -->
    </div>
    <div v-if="!noDataFlag">
      <!-- 分页 -->
      <div class="pagination-box">
        <el-pagination
          style="margin-top: 20px"
          :pager-count="5"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="formInline.page"
          :total="formInline.total"
          :page-size.sync="formInline.limit"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <div v-if="!noDataFlag" id="orderNow" class="order-now">
      <div class="order-now-left">
        <input
          v-if="totalCount != selectCount"
          v-model="checked"
          type="checkbox"
          :class="{ 'no-border': totalCount != selectCount }"
          @click="checkAll"
        />
        <div v-else class="check-img">
          <img src="@/assets/img/purchase/right.svg" alt="" @click="checkAll" />
        </div>
        <span class="choose">已选</span>
        <span class="red margin-both">
          {{ selectCount }}
        </span>
        条采购申请
      </div>
      <div class="order-now-right">
        <div class="detail">
          <div class="all">
            合计金额：
            <span class="red">¥ {{ moneySum }}</span>
          </div>
        </div>
        <div class="button">
          <!-- <img src="~/assets/images/orderDetail/order-now.png" alt="" /> -->
          <div @click="setOrder">立即订购</div>
        </div>
      </div>
    </div>
    <eDialog
      :dialog-type="dialogType"
      :dialog-title="dialogTitle"
      :dialog-content="dialogContent"
      :show-btn="true"
      :center-dialog-visible="visible"
      :popup-width="'600px'"
      @updateVisible="visible = false"
      @resetPopupData="visible = false"
      @submitPopupData="submitPopupData"
    ></eDialog>
  </div>
</template>
<script>
import {orderBaseUrl } from '@/modules/projectA/api/config';
import { durationTime } from '@/modules/projectA/utils/utils';
import Api from '@/modules/projectA/api/purchase';
import { format } from 'echarts';
import eBuyNum from './e-buy-num-product';
import eDialog from './e-dialog.vue';
import eSearch from '../../../components/common/e-search';
import eTooltip from '../../../components/common/e-tooltip';

export default {
  name: 'GenerateOrder',
  components: { eBuyNum, eDialog, eSearch, eTooltip },
  data() {
    return {
      filterInfo: {
        data: {
          purchaseRequisitionCode: null,
          saveStatus: null,
          productName: null,
          materielCode: null,
        },
        fieldList: [
          {
            label: '采购申请号',
            type: 'input',
            value: 'purchaseRequisitionCode',
          },
          {
            label: '商品是否保存',
            type: 'select',
            value: 'saveStatus',
            list: 'saveStatusList',
          },
          { label: '商品名称', type: 'input', value: 'productName' },
          { label: '企业物料编码', type: 'input', value: 'materielCode' },
        ],
        width: {
          labelWidth: 130,
          itemWidth: 160,
        },
      },
      listTypeInfo: {
        saveStatusList: [
          { id: null, name: '全部' },
          { id: 0, name: '是' },
          { id: 1, name: '否' },
        ],
      },
      visible: false,
      dialogType: '',
      dialogTitle: '',
      dialogContent: '',
      noDataFlag: false,
      isFixed: false,
      toSubmitFlag: true,
      checked: false,
      user: '',
      formInline: {
        purchaseRequisitionCode: null,
        saveStatus: null,
        productName: null,
        materielCode: null,
        createTimeSort: 'DESC',
        limit: 10, // 每页条数
        page: 1, // 页码
        total: 0,
        clickQuery: 0, // 固定传0
        track: 0,
      },
      user1: '',
      user2: '',
      user3: '',
      options: [
        {
          value: null,
          label: '全部',
        },
        {
          value: '0',
          label: '是',
        },
        {
          value: '1',
          label: '否',
        },
      ],
      num: '1',
      isSort: true,
      isDel: false,
      isBtnLight: false,
      checkModel: [],
      totalCount: 0,
      selectCount: 0,
      myPurchaseRequestData: [], // 申请数据明细，操作数据
      moneySum: 0,
      checkedNum: 0,
      orderList: [],
      addressList: [],
      activeAddress: {},
      invoeicList: [], // 发票列表
      activeInvoeicItem: {},
      invoiceInfo: [],
      activeInvoice: {},
      approvalList: [],
    };
  },
  watch: {
    // 监视双向绑定的数据数组
    checkModel() {
      if (this.checkModel.length === this.checkedNum && this.checkedNum > 0) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    myPurchaseRequestData: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.$nextTick(() => {
            window.addEventListener('scroll', this.initHeight);
          });
        }
      },
    },
  },
  mounted() {
    window.addEventListener('scroll', this.initHeight);
    this.queryProcurementPlan();
  },
  destroyed() {
    window.removeEventListener('scroll', this.initHeight);
  },
  methods: {
    handleFilter(val) {
      this.formInline.purchaseRequisitionCode = val.purchaseRequisitionCode;
      this.formInline.saveStatus = val.saveStatus;
      this.formInline.productName = val.productName;
      this.formInline.materielCode = val.materielCode;
      this.formInline.page = 1;
      this.queryProcurementPlan();
    },
    handleReset() {
      this.formInline.purchaseRequisitionCode = null;
      this.formInline.saveStatus = null;
      this.formInline.productName = null;
      this.formInline.materielCode = null;
      this.formInline.page = 1;
      this.queryProcurementPlan();
    },
    setOrder() {
      if (this.checkModel.length == 0) {
        this.$message.warning('请先勾选采购申请，再操作立即订购。');
        return;
      }
      // 有选中的商品
      let isSelect = false;
      for (let i = 0; i < this.myPurchaseRequestData.length; i++) {
        this.checkModel.forEach((item) => {
          if (
            item == this.myPurchaseRequestData[i].purchaseRequisitionId &&
            this.myPurchaseRequestData[i].purchasePlanItemListVOList &&
            this.myPurchaseRequestData[i].purchasePlanItemListVOList.length >
              0 &&
            Number(
              this.myPurchaseRequestData[i].remainingQuantity != null
                ? this.myPurchaseRequestData[i].remainingQuantity
                : this.myPurchaseRequestData[i].remainingQuantity
            ) > 0
          ) {
            isSelect = true;
          }
        });
      }
      if (isSelect) {
        // this.$router.push({ path: `/order`, query: { flag: 'procurementPlan' } });
        window.open(`${orderBaseUrl}/order?from=v&flag=procurementPlan`, '_blank');
      } else {
        this.$message({
          message: '您当前勾选的采购申请还未选择商品，请先完成商品选择。',
          type: 'warning',
          duration: durationTime(),
        });
      }
    },
    sortChange() {
      this.isSort = !this.isSort;
      this.queryProcurementPlan();
    },
    // 判断是否有选中商品 和 剩余数量是否 大于0
    isSelect(item) {
      if (
        typeof item.purchasePlanItemListVOList !== 'undefined' &&
        Number(
          item.remainingQuantity != null &&
            item.remainingQuantity != 'undefined'
            ? item.remainingQuantity
            : item.remainingQuantity
        ) > 0
      ) {
        return true;
      }
      return false;
    },
    async submitPopupData() {
      const res = await Api.cancelProcurementPlan({
        purchaseRequisitionId: this.purchaseRequisitionId,
      });
      if (res.code == '200') {
        this.$message({
          message: '退回成功。',
          type: 'success',
          duration: durationTime(),
        });
        this.queryProcurementPlan();
        this.visible = false;
      }
    },
    // 退回
    returnNum(id) {
      this.purchaseRequisitionId = id;
      this.dialogTitle = '退回提示';
      this.dialogContent = '采购申请将会退回到SCM采购系统，是否继续？';
      this.dialogType = 'warning';
      this.visible = true;
    },
    // 初始化数据
    async queryProcurementPlan() {
      if (this.isSort) {
        this.formInline.createTimeSort = 'DESC';
      } else {
        this.formInline.createTimeSort = 'ASC';
      }
      const res = await Api.queryProcurementPlan(this.formInline);
      if (res.code == '200') {
        this.totalCount = res.data.totalCount; // 供应商下所有订单采购的数量
        this.selectCount = res.data.selectCount; // 选的条数

        this.myPurchaseRequestData = res.data.purchasePlanVOList
          ? res.data.purchasePlanVOList
          : [];

        this.checkedNum = 0;
        if (this.myPurchaseRequestData.length == 0) {
          this.noDataFlag = true;
          return;
        }
        this.myPurchaseRequestData.forEach((item) => {
          if (this.isSelect(item)) {
            this.checkedNum++;
          }
        });

        this.noDataFlag = false;

        this.formInline.total = res.data.totalCount;

        for (let i = 0; i < this.myPurchaseRequestData.length; i++) {
          if (
            this.myPurchaseRequestData[i].isSelected == 1 &&
            this.checkModel.findIndex(
              (item) =>
                item == this.myPurchaseRequestData[i].purchaseRequisitionId
            ) == -1
          ) {
            this.checkModel.push(
              this.myPurchaseRequestData[i].purchaseRequisitionId
            );
          }
        }
        this.moneySum = res.data.totalAmount;
      }
    },
    // 采购申请 每条类目选中或取消返回总价
    async cancleClick(item, index) {
      const res = await Api.checkPurchasePlanRequest({
        checkedStatus: 0,
        purchaseRequisitionId: item.purchaseRequisitionId,
      });
      if (res.code == '200') {
        this.moneySum = res.data;
      }
      this.checkModel.splice(
        this.checkModel.findIndex(
          (itemData) => itemData == item.purchaseRequisitionId
        ),
        1
      );
      this.queryProcurementPlan();
    },
    // 采购申请全部选中或取消返回总价
    async checkPurchaseRequest(item, index) {
      const num = this.checkModel.findIndex(
        (itemData) => itemData == item.purchaseRequisitionId
      );
      const res = await Api.checkPurchasePlanRequest(
        !item
          ? {
              purchaseRequisitionId: '',
              checkedStatus: this.checkModel.length > 0 ? 1 : 0,
            }
          : {
              checkedStatus: num == '-1' ? 0 : 1,
              purchaseRequisitionId: item.purchaseRequisitionId,
            }
      );
      if (res.code == '200') {
        this.moneySum = res.data;
        this.queryProcurementPlan();
      }
    },
    reset() {
      this.formInline = {
        purchaseRequisitionCode: null,
        saveStatus: null,
        productName: null,
        materielCode: null,
        createTimeSort: 'DESC',
        limit: 10, // 每页条数
        page: 1, //
        total: 0,
        clickQuery: 0,
        track: 0,
      };
      this.queryProcurementPlan(this.formInline);
    },
    toBack() {
      this.$router.push({ path: `/` });
    },

    // 翻页
    handleCurrentChange(val) {
      this.formInline.page = val;
      this.queryProcurementPlan();
    },
    handleSizeChange(val) {
      console.log(val, 'dfdfdf');
      this.formInline.page = 1;
      this.formInline.limit = val;
      this.queryProcurementPlan();
    },
    setShoppingStandard(param) {
      let content = '';
      if (param) {
        try {
          const data = JSON.parse(param);
          for (let i = 0; i < data.length; i++) {
            content += `${data[i].salesPropertyInfoName}:${data[i].salesPropertyInfoValue};`;
          }
        } catch (e) {
          console.log(e);
        }
      }
      return content;
    },
    async handleChange(num, value) {
      const res = await Api.updateProcurementPlanQuantity({
        quantity: num || 0,
        procurementPlanItemId: value,
      });
      if (res.code == '200') {
        this.moneySum = res.data;
        this.toSubmitFlag = true;
      } else {
        this.toSubmitFlag = false;
      }
    },
    selectBtn(value, productName) {
      this.$router.push({
        path: `/fusePurchaseRequest/fuseChooseGoods`,
        query: { purchaseRequisitionId: value, productName },
      });
    },
    enter(value) {
      this.isDel = value;
    },
    leave(value) {
      this.isDel = value;
    },
    checkAll() {
      if (this.checkModel.length > 0) {
        this.checkModel = [];
      } else {
        this.myPurchaseRequestData.forEach((item) => {
          if (this.checkModel.indexOf(item.purchaseRequisitionId) == -1) {
            this.checkModel.push(item.purchaseRequisitionId);
          }
        });
      }
      this.checkPurchaseRequest('', '');
    },
    // 删除已选采购申请
    async deleteSelectedPurchaseRequest() {
      if (this.checkModel.length == 0) {
        this.$message({
          message: '请选择要删除的采购申请。',
          type: 'warning',
          duration: durationTime(),
        });
        return;
      }

      this.$confirm(`您正在操作删除已选采购申请，请仔细核对并确认。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async () => {
        const res = await Api.deleteProcurementPlanRequest({});
        if (res.code == '200') {
          this.$message({
            message: '删除已选采购申请成功',
            type: 'success',
            duration: durationTime(),
          });
          this.checkModel = [];
          this.queryProcurementPlan();
        }
      });
    },
    initHeight() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // scrollTop = scrollTop+634;
      // console.log(scrollTop, '这是scrollTop');
      // let height =  document.documentElement.clientHeight || document.body.clientHeight;
      // let scorllHeight =  document.body.scrollHeight  ||document.documentElement.scrollHeight;
      const height =
        document.documentElement.clientHeight || document.body.clientHeight;

      const div = document.getElementById('orderNow');
      const divToTop = div.offsetTop;
      // console.log(divToTop);
      if (scrollTop + height < divToTop) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/css/mixin/flex.scss';
@import '@/assets/css/theme.scss';
.generate-order {
  background: #fff;
  .header {
    display: flex;
    justify-content: space-around;
  }
  .no-border {
    -webkit-appearance: none;
    border: 1px solid #dcdfe6;
    width: 18px;
    height: 18px;
  }
  .check-img {
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    background-color: #2587ff;
    img {
      width: 11px;
      height: 8px;
      margin-top: 2px;
    }
  }
  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .text-value {
    color: #333;
    font-size: 14px;
  }
  .generate-order-container {
    padding: 10px 0;
    border: 1px solid #d9d9d9;
    box-sizing: border-box;
    margin-bottom: 20px;
    ::v-deep .el-form {
      .el-form-item__label {
        color: #333;
      }
      .el-form-item {
        input::-webkit-input-placeholder {
          color: #999;
        }
        input::-moz-input-placeholder {
          color: #999;
        }
        input::-ms-input-placeholder {
          color: #999;
        }
      }
    }

    .button {
      display: flex;
      justify-content: center;
      margin-bottom: 10px;
      margin-top: 6px;
    }

    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 2px;
        margin-left: 40px;
        .el-form-item__content {
          input {
            width: 200px;
            height: 30px;
            line-height: 30px;
          }

          .el-range-input {
            width: 80px;
          }

          .el-range-separator {
            width: 30px;
          }

          .el-date-editor {
            width: 200px;
          }

          .el-button:focus,
          .el-button:hover {
            color: #333333;
            background-color: transparent;
          }

          .el-checkbox-group {
            margin-left: 70px;
            .is-checked + .el-checkbox__label {
              color: #333333;
            }
          }

          .el-date-editor {
            height: 30px;

            i:nth-child(1) {
              display: none;
            }

            .el-range__close-icon {
              line-height: 22px;
            }

            input {
              height: 25px;
            }

            .el-range-separator {
              height: 25px;
              line-height: 25px;
            }
          }

          .el-button {
            padding: 9px 27px;
          }

          .reset-btn {
            margin: 0 20px 0 80px;
          }
        }
      }
    }
  }
  ::v-deep.el-input__inner {
    border-radius: 0;
    color: #333;
  }

  .generate-order-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    padding: 10px 20px;
    border: 1px solid #d9d9d9;
    margin-bottom: 20px;
    box-sizing: border-box;

    ::v-deep .el-checkbox__label {
      font-weight: bold;
      color: #333333;
    }

    .generate-order-top-left {
      display: flex;
      align-items: center;

      .generate-order-top-left-input {
        display: flex;
        align-items: center;

        input[type='checkbox'] {
          cursor: pointer;
          position: relative;
          width: 18px;
          height: 18px;
          -webkit-appearance: none;
        }

        input[type='checkbox']::after {
          position: absolute;
          top: 0;
          color: #000;
          width: 18px;
          height: 18px;
          display: inline-block;
          visibility: visible;
          padding-left: 0px;
          text-align: center;
          content: '';
        }
        p {
          margin-left: 10px;
          font-weight: bold;
        }
      }

      .generate-order-top-left-sort {
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-left: 40px;
        box-sizing: border-box;

        img {
          width: 13px;
          height: 15px;
          margin-left: 10px;
        }
      }
    }

    .generate-order-top-right {
      display: flex;
      align-items: center;
      cursor: pointer;

      img {
        width: 14px;
        height: 16px;
      }

      div {
        margin-left: 10px;
      }

      .text-color {
        color: #0064c8;
      }
    }
  }
  .is-active {
    background-color: #f4f7ff;
  }
  .generate-order-main {
    display: flex;
    flex-direction: column;
    border: 1px solid #d9d9d9;
    box-sizing: border-box;
    position: relative;
    padding: 10px 0;

    .margin-l {
      margin-left: -8px;
    }
    .order-item {
      width: 1066px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;

      .index-item {
        padding-right: 20px;
        /*width: 40px;*/
        /*margin-right: 20px;*/
      }
      .order-item-main {
        width: 758px;
        display: flex;
        justify-content: space-between;
        padding-left: 20px;
        border-left: 1px solid #d9d9d9;
        position: relative;
        margin-left: -178px;
        .left-line {
          position: absolute;
          border-left: 1px solid #d9d9d9;
          width: 1px;
          height: 54px;
          left: -1px;
          top: 69px;
        }

        .order-item-left {
          padding-top: 12px;
          box-sizing: border-box;
          img {
            width: 12px;
            height: 12px;
          }
          .img-input {
            position: relative;
          }
          .img-right {
            width: 18px;
            height: 18px;
            position: absolute;
            top: 12px;
            left: 21px;
            background-color: #2587ff;
            line-height: 18px;
            text-align: center;
            img {
              margin-top: 4px;
              width: 12px;
            }
          }

          input[type='checkbox'] {
            cursor: pointer;
            position: relative;
            width: 18px;
            height: 18px;
            border-radius: 0;
            -webkit-appearance: none;
          }
          // input[type=checkbox]:checked{
          //   background: url("../../../assets/images/right.svg") no-repeat #2587FF;
          //   background-position: 4px 6px;
          //   background-size: 11px 8px;
          //   width: 18px;
          //   height: 18px;
          // }
          input[type='checkbox']::after {
            color: #000;
            width: 18px;
            height: 18px;
            display: inline-block;
            visibility: visible;
            padding-left: 0px;
            text-align: center;
          }
        }

        .order-item-middle {
          ul {
            display: flex;
            flex-wrap: wrap;
            width: 886px;
            font-size: 12px;

            li {
              display: flex;
              width: 198px;
              padding: 8px 0 14px;
              box-sizing: border-box;

              &:nth-of-type(4n + 1) {
                margin-left: 6px;
              }

              .text {
                color: #999;
              }

              .text86 {
                width: 104px;
              }

              .text70 {
                width: 80px;
              }

              .text75 {
                width: 75px;
              }

              .text85 {
                width: 104px;
              }

              .text100 {
                width: 102px;
              }
              .text99 {
                width: 114px;
              }

              .text115 {
                width: 115px;
              }

              .isActive {
                color: #333;
              }

              .requestno {
                max-width: 104px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .text-value {
                color: #333;
                font-size: 14px;
              }
              .t-132 {
                width: 132px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .text-value-number {
                width: 80px;
              }

              .text-value-number150 {
                width: 150px;
              }
            }

            li:nth-child(n + 5) {
              padding: 0 0 15px 0;
              box-sizing: border-box;
            }

            .li-width-196 {
              width: 152px;
            }
          }
        }
      }

      .order-item-right {
        margin-left: -22px;
        text-align: center;
        position: relative;
        left: -122px;
      }
    }
    .line-item {
      margin-left: 35px;
    }
    ::v-deep .el-input__inner {
      border-radius: 0;
    }
    .left-item {
      padding-left: 40px;
    }
    .order-item-footer {
      width: 822px;
      display: flex;
      align-items: center;
      padding: 10px 10px 10px 0;
      border: 1px solid #666;
      box-sizing: border-box;
      margin: 10px 20px 10px 101px;
      justify-content: space-around;
      > div {
        display: flex;
        align-items: center;
        margin-left: 12px;

        .text {
          color: #333;
          font-size: 12px;
        }
        .isActive {
          color: #333;
        }

        .text-width-150 {
          width: 141px;
        }
      }

      .commodity {
        margin-left: 10px;
        display: flex;

        .ellipsis {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .order-item-footer-text {
          display: flex;
          margin-left: 10px;
        }
      }
      .width {
        width: 74px;
      }
      .order-size {
        p {
          padding-right: 10px;
        }
        .lw-3 {
          // flex:1;
          width: 122px;
          @include flex(center, center, row);
          ::v-deep .el-input__inner {
            border-radius: 0;
          }
        }
      }
    }

    > img {
      position: absolute;
      top: 39px;
      left: 45px;
      width: 23px;
      height: 78px;
    }

    .isMainActive {
      background: #f4f7ff;
    }
  }
  .line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .back {
      width: 80px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #d9d9d9;
      text-align: center;
      cursor: pointer;
      &:hover {
        border: 1px solid #2587ff;
        color: #2587ff;
      }
    }
    .margin {
      margin-top: 20px;
    }
  }
  .no-data {
    text-align: center;
    margin-bottom: 30px;
    img {
      margin-top: 60px;
      width: 204px;
      height: 124px;
    }
    p {
      margin-top: 10px;
      color: #333;
      font-size: 16px;
      span {
        color: #2587ff;
        cursor: pointer;
      }
    }
  }
  .order-now {
    height: 59px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 40px;
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.5);
    z-index: 100;
    .is-fixed-wrap {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      .is-fixed-right {
        flex: 1;
        display: flex;
        justify-content: space-between;
        width: 1010px;
      }
    }
    &.is-fixed {
      position: fixed;
      bottom: 0;
      width: 100%;
      padding: 0;
      left: 0;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
      z-index: 999;
    }
    .red {
      color: red;
    }
    .margin-both {
      margin: 0 10px;
    }
    .order-now-left {
      margin-left: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      .choose {
        margin-left: 16px;
      }
    }
    .order-now-right {
      display: flex;
      align-items: center;

      .detail {
        .all {
          font-weight: bold;
          color: #333333;
          font-size: 16px;
        }
        span {
          margin-right: 10px;
        }
      }
      .button {
        height: 60px;
        line-height: 60px;
        width: 130px;
        text-align: center;
        background-color: red;
        color: white;
        font-weight: bold;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
        cursor: pointer;
        img {
          width: 16px;
          height: 22px;
        }
      }
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
  .pagination-box {
    text-align: right;
  }
}
</style>
